module.exports = __webpack_public_path__ + "static/img/12.88e1a2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/12.png
// module id = iqbb
// module chunks = 0